import * as React from "react";
import {Box, Skeleton, Typography} from "@mui/material";
import TopDebtorsRowsSkeleton from "./TopDebtorsRowsSkeleton";
import AgingTierScale from "../AgingTierScale";

export default function PortfolioAgingSkeleton() {
    const tierCardsCount = AgingTierScale.default().tiersCount();
    return (
        <Box sx={{marginBottom: 3}}>
            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 1}}>
                <Typography variant="h6">Aging de deuda</Typography>
                <Skeleton variant="rectangular" width={140} height={32} sx={{borderRadius: 0.8}}/>
            </Box>
            <Skeleton variant="rectangular" height={14} sx={{borderRadius: 0.5, marginTop: 1, marginBottom: 2}}/>
            <Box sx={{display: 'grid', gridTemplateColumns: `repeat(${tierCardsCount}, minmax(0, 1fr))`, gap: 1, marginBottom: 3}}>
                {Array(tierCardsCount).fill(null).map((agingTierCardPlaceholder, cardIndex) => (
                    <Skeleton key={cardIndex} variant="rectangular" height={92} sx={{borderRadius: 0.8}}/>
                ))}
            </Box>
            <TopDebtorsRowsSkeleton/>
        </Box>
    );
}
